const useStyles = theme => ({
    container: {
      position: 'relative',
    },
    playButtonArrow: {
      fontSize: 35,
      [theme.breakpoints.only('md')]: {
        fontSize: 40,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 25,
      },
    },
    previewImageContainer: {
      height: '100%',
      width: '100%',
    },
    previewImage: {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
    durationBox: {
      bottom: '5px',
      right: '5px',
      position: 'absolute',
      zIndex: 2,
    },
    playButton: {
      position: 'absolute',
      height: '60px',
      width: '60px',
      borderRadius: 40,
      zindex: 2,
      [theme.breakpoints.only('md')]: {
        height: '68px',
        width: '68px',
      },
      [theme.breakpoints.down('sm')]: {
        height: '45px',
        width: '45px',
      },
    },
    title: {
      display: "-webkit-box",
      boxOrient: "vertical",
      lineClamp: 2,
      zIndex: 2,
      wordBreak: "break-word",
      overflow: "hidden",
      bottom: '20px',
      left: '20px',
      right: '70px',
      position: 'absolute',
      // Sizes: S
      [theme.breakpoints.down('sm')]: {
        bottom: '10px',
        left: '5px',
        right: '60px'
      },
    },
    gradientBox: {
      opacity: 0.3,
      zIndex: 0,
      position: 'absolute',
      height: '100%',
      width: '100%',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.1), black)',
    },
});

export default useStyles
